module.exports = __webpack_public_path__ + "static/media/power-line.37d4d4d4.svg";